function isStatusActive(status) {
  return status === 'active';
}

export { isStatusActive };
